import DataTablePage from 'components/DataTablePage';
import { useParams } from 'react-router-dom';
import { getNHMetrics, getNHMetricsByBetLimit } from 'services/nh-metrics';
import nhMetricColumnData from 'data/nhMetricColumnData';

function NHMetrics() {
  const { betLimitId } = useParams();

  const fetchData = async (limit = 20, page = 1, filters = {}) => {
    if (betLimitId) {
      return await getNHMetricsByBetLimit(betLimitId, limit, page);
    }
    return await getNHMetrics(limit, page, filters);
  };

  const queryKey = ['nh-metrics', betLimitId];

  return (
    <DataTablePage
      title={betLimitId ? `NH Metrics for Bet Limit: ${betLimitId}` : 'NH Metrics'}
      canSearch
      canFilter={!betLimitId}
      fetchData={fetchData}
      queryKey={queryKey}
      columnData={nhMetricColumnData}
      object='nh-metric'
      noActions
      filters={betLimitId ? { betLimitId } : {}}
    />
  );
}

export default NHMetrics;
